import { Button, Card, Divider, Form, Input } from "antd";
import { LockOutlined, UserOutlined } from "@ant-design/icons";
import i18n from "i18next";
import React from "react";
import "./Login.scss";
import { useNavigate } from "react-router-dom";


function LoginCard(props) {
  const navigate = useNavigate();

  return (
    <Card title={"Melde dich mit deiner E-mail Adresse an"} className="card">
      <Form
        name="normal_login"
        className="login-form"
        onFinish={props.onFinish}
      >
        <Form.Item
          name="username"
          className="form-item"
          rules={[
            {
              required: true,
              message: "Eine E-mail Adresse eingeben",
            },
          ]}
        >
          <Input
            prefix={<UserOutlined className="site-form-item-icon" />}
            placeholder={"E-mail"}
          />
        </Form.Item>
        <Form.Item
          name="password"
          className="form-item"
          rules={[
            {
              required: true,
              message: "Ein Passwort eingeben",
            },
          ]}
        >
          <Input
            prefix={<LockOutlined className="site-form-item-icon" />}
            type="password"
            placeholder={"Passwort"}
          />
        </Form.Item>

        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            className="login-form-button card-first-btn"
          >
            {"Einloggen"}
          </Button>
        </Form.Item>
      </Form>

      <div className="flex-center">
        <Button
          type="primary"
          htmlType="submit"
          className="login-form-button card-first-btn"
          onClick={() => {
            navigate("/forgotPwd");
          }}
        >
          {"Passwort vergessen?"}
        </Button>
      </div>
    </Card>
  );
}

export default LoginCard;
